module.exports = __webpack_public_path__ + "img/brazil.c0cdb701.jpg";